import React from "react";
import { ShieldAlert, Hammer } from "lucide-react";

export default function SecurityTab() {
  return (
    <div className="p-fluid-5 flex flex-col items-center justify-center text-center h-full">

      {/* Icon wrapper */}
      <div className="relative mb-fluid-3">
        {/* Glow */}
        <div className="absolute inset-0 bg-[#223688]/20 dark:bg-[#31C4AB]/20 blur-2xl rounded-full" />
        
        {/* Main Icon */}
        <div className="relative flex items-center justify-center w-[5rem] h-[5rem] rounded-full 
                        bg-[#223688]/10 dark:bg-[#31C4AB]/10 border border-gray-300 dark:border-acs-dark-border">
          <ShieldAlert className="w-10 h-10 text-[#223688] dark:text-[#31C4AB]" />
        </div>
      </div>

      {/* Title */}
      <h2 className="text-fluid-xl font-semibold text-gray-900 dark:text-white mb-fluid-1">
        Security Settings Coming Soon
      </h2>

      {/* Subtitle */}
      <p className="text-fluid-base text-gray-600 dark:text-acs-dark-subtext max-w-[30rem] mb-fluid-3">
        We’re working on adding security controls Stay tuned!
      </p>

      {/* Construction banner */}
      <div className="
        flex items-center gap-fluid-2 
        bg-yellow-100 dark:bg-yellow-500/20 
        text-yellow-800 dark:text-yellow-300 
        px-fluid-4 py-fluid-2 
        rounded-lg border border-yellow-300/50 dark:border-yellow-500/40
      ">
        <Hammer className="w-fluid-icon-sm h-fluid-icon-sm" />
        <span className="text-fluid-sm font-medium">
          Under Construction...
        </span>
      </div>

    </div>
  );
}
